import getFiltersOption from '../store/store';
import MailboxJunkEmailConfigurationOptions from 'owa-service/lib/contract/MailboxJunkEmailConfigurationOptions';
import OwaUserConfiguration from 'owa-service/lib/contract/OwaUserConfiguration';
import { mutatorAction } from 'satcheljs';

export default mutatorAction(
    'saveFiltersOptionHelper',
    (
        mailboxJunkEmailConfiguration: MailboxJunkEmailConfigurationOptions,
        userConfiguration: OwaUserConfiguration
    ) => {
        const filtersOptionState = getFiltersOption();

        if (filtersOptionState.trustedListsOnly != null) {
            mailboxJunkEmailConfiguration.TrustedListsOnly = filtersOptionState.trustedListsOnly;
        }
        if (filtersOptionState.contactsTrusted != null) {
            mailboxJunkEmailConfiguration.ContactsTrusted = filtersOptionState.contactsTrusted;
        }
        if (filtersOptionState.blockContentFromUnknownSenders != null) {
            userConfiguration.SafetyUserOptions.BlockContentFromUnknownSenders =
                filtersOptionState.blockContentFromUnknownSenders;
        }
    }
);
